"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningStatusIcon = void 0;
const react_1 = __importDefault(require("react"));
const WarningStatusIcon = () => (react_1.default.createElement("svg", { viewBox: "0 0 16 16", width: "16", height: "16" },
    react_1.default.createElement("polygon", { fill: "#f2c973", points: "15 15 1 15 8 1 15 15" }),
    react_1.default.createElement("polygon", { fill: "#444", points: "8.75 11 7.25 11 7 5 9 5 8.75 11" }),
    react_1.default.createElement("circle", { fill: "#444", cx: "8", cy: "13", r: "1" })));
exports.WarningStatusIcon = WarningStatusIcon;
//# sourceMappingURL=WarningStatusIcon.js.map